import { projects, type Project } from '@/mocks/projects';

export const orderedProjects: Project[] = [...projects].sort((a, b) => a.order - b.order);

export const getProjectBySlug = (slug?: string) => orderedProjects.find((p) => p.slug === slug);

export const getAdjacentProjects = (slug: string) => {
  const i = orderedProjects.findIndex((p) => p.slug === slug);
  const n = orderedProjects.length;
  return {
    prev: orderedProjects[(i - 1 + n) % n],
    next: orderedProjects[(i + 1) % n],
  };
};

/** One photograph in the Work archive — derived from projects[].images[], never duplicated. */
export interface GalleryItem {
  id: string;
  image: Project['images'][number];
  projectSlug: string;
  projectImageIndex: number;
  project: Project;
}

/**
 * Interleaved round-robin: round k takes image k from every project, rotated by 3k so
 * the same project never sits next to itself horizontally or vertically in a 4-col grid.
 */
export const galleryItems: GalleryItem[] = (() => {
  const n = orderedProjects.length;
  const rounds = Math.max(0, ...orderedProjects.map((p) => p.images.length));
  const out: GalleryItem[] = [];
  for (let k = 0; k < rounds; k += 1) {
    for (let j = 0; j < n; j += 1) {
      const project = orderedProjects[(j + k * 3) % n];
      const image = project.images[k];
      if (image) {
        out.push({ id: `${project.slug}-${k}`, image, projectSlug: project.slug, projectImageIndex: k, project });
      }
    }
  }
  return out;
})();

export const formatIndex = (order: number) => String(order).padStart(2, '0');